import { createPortal } from 'react-dom';
import { create } from 'zustand';
import { DialogoConfirmar } from './Dialogo';

interface Pedido {
  titulo: string;
  texto: string;
  confirmar: string;
  cancelar?: string;
  peligro?: boolean;
  responder: (si: boolean) => void;
}

const usePedidos = create<{ pedido: Pedido | null }>(() => ({ pedido: null }));

/**
 * Pide una confirmación desde cualquier acción (por ejemplo, exportar un proyecto con datos reales)
 * y espera la respuesta. Se dibuja encima de los demás diálogos.
 */
export function confirmar(p: Omit<Pedido, 'responder'>): Promise<boolean> {
  return new Promise((resolver) => {
    usePedidos.getState().pedido?.responder(false);
    usePedidos.setState({ pedido: { ...p, responder: resolver } });
  });
}

function responder(si: boolean) {
  const p = usePedidos.getState().pedido;
  usePedidos.setState({ pedido: null });
  p?.responder(si);
}

export function Confirmaciones() {
  const pedido = usePedidos((s) => s.pedido);
  if (!pedido) return null;
  return createPortal(
    <div className="capa-confirmacion">
      <DialogoConfirmar
        titulo={pedido.titulo}
        textoConfirmar={pedido.confirmar}
        {...(pedido.cancelar ? { textoCancelar: pedido.cancelar } : {})}
        peligro={pedido.peligro ?? false}
        alConfirmar={() => responder(true)}
        alCancelar={() => responder(false)}
      >
        {pedido.texto}
      </DialogoConfirmar>
    </div>,
    document.body,
  );
}
